
export type SiteKey = 'guidance' | 'itsupport' | 'workflow';

export interface SiteConfig {
    companyname: string;
    name: string;
    logo: string;
    primaryColor: string;
    navLinks: {
        label: string; href: string, icon: string, isTopLevel?: boolean;

    }[];
    heroTitle: string;
    heroSubtitle: string;

    headerHeight?: number;
    headerTextColor?: string;
    headerBgShade?: string;       // Darker / lighter variant of primary
    logoWidth?: number;
    logoHeight?: number;
    sidebarColor?: string;
    phonenumber?: string;
}

export const sites: Record<SiteKey, SiteConfig> = {

    guidance: {
        companyname: 'Nordisk Guidance',
        name: 'Student Admission Guidance',
        logo: process.env.PUBLIC_URL + '/logos/nordisklogo.png',
        primaryColor: '#757575', // blue

        navLinks: [
            { label: 'Home', href: 'home', icon: 'Home', isTopLevel: false },
            { label: 'Requirements', href: 'require', icon: 'Checklist', isTopLevel: false },
            { label: 'Facilities', href: 'facilities', icon: 'Business', isTopLevel: false },
            { label: 'About Us', href: 'about', icon: 'Info', isTopLevel: false },
            { label: 'Contact', href: 'contact', icon: 'Mail', isTopLevel: false },
        ],
        heroTitle: 'Study and Build Your Future in Denmark',
        heroSubtitle: 'Guidance for admission, visa, and job opportunities.',

        headerHeight: 80,
        headerTextColor: '#FFFFFF',
        headerBgShade: 'cadetblue',
        logoWidth: 180,
        logoHeight: 180,
        sidebarColor: 'cadetblue',
    },

    itsupport: {
        companyname: 'Nordisk Support',
        name: 'Where Technology Meets Reliability',
        logo: process.env.PUBLIC_URL + '/logos/nordisk.png',
        primaryColor: '#3c3c3c',
        navLinks: [
            { label: 'Home', href: 'home', icon: 'Home', isTopLevel: true },
            { label: 'IT Support', href: 'itservices', icon: 'Computer', isTopLevel: true },
            { label: 'Software Solutions', href: 'swservices', icon: 'Code', isTopLevel: true },
            { label: 'Data Engineering', href: 'dataservices', icon: 'Storage', isTopLevel: true },
            { label: 'Contact', href: 'contact', icon: 'Mail', isTopLevel: true },
            { label: 'Careers', href: 'careers', icon: 'Career', isTopLevel: true },
            { label: 'About Us', href: 'about', icon: 'Info', isTopLevel: true }

        ],
        heroTitle: 'Professional IT & Network Support',
        heroSubtitle: 'Reliable, affordable, and fast tech support for your business.',

        headerHeight: 90,
        headerTextColor: '#FFFFFF',
        headerBgShade: 'cadetblue',
        logoWidth: 85,
        logoHeight: 85,
        sidebarColor: 'white',
        phonenumber: '+45 66 77 69 51',
    },

    workflow: {
        companyname: 'Nordisk Workflow',
        name: 'Hygiene Support Services',
        logo: process.env.PUBLIC_URL + '/logos/nordiskworkflow.png',
        primaryColor: '#0D9488', // blue
        navLinks: [
            { label: 'Home', href: 'home', icon: 'Home', isTopLevel: false },
            { label: 'Services', href: 'services', icon: 'Devices', isTopLevel: false },
            { label: 'Booking', href: 'booking', icon: 'Calendar', isTopLevel: false },
            { label: 'About', href: 'about', icon: 'Info', isTopLevel: false },
            { label: 'Contact', href: 'contact', icon: 'Mail', isTopLevel: false },

        ],
        heroTitle: 'Restaurant & Facility Hygiene Operations',
        heroSubtitle: 'Professional dishwashing, cleaning, and back-of-house flow support.',

        headerHeight: 75,
        headerTextColor: '',
        headerBgShade: '#66a6ff',
        logoWidth: 60,
        logoHeight: 60,
        sidebarColor: '#66a6ff',
        phonenumber: '+45 42 22 84 26',
    },
};
